import { render, staticRenderFns } from "./LayoutMiniature.vue?vue&type=template&id=3ef9fc32&scoped=true&"
import script from "./LayoutMiniature.vue?vue&type=script&lang=js&"
export * from "./LayoutMiniature.vue?vue&type=script&lang=js&"
import style0 from "./LayoutMiniature.vue?vue&type=style&index=0&id=3ef9fc32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef9fc32",
  null
  
)

export default component.exports